// extracted by mini-css-extract-plugin
export default {"linkview":"linkview_e4a69d07de7fe7477cf9","icon":"icon_ba6ff6fad7ed851977b3"};